import styles from './AboutPrice.module.scss';

const AboutPrice = ({ aboutPrice }) => {
  if(!aboutPrice) return null;
  const aboutLines = aboutPrice.split('\n');
  return (
    <div className={styles.root}>
      <h3 className={styles.title}>料金表について</h3>
      <ul>
        {aboutLines.map((line, index) => (
          <li key={index}>
            ・{line}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default AboutPrice;
